import { render, staticRenderFns } from "./add-connector.vue?vue&type=template&id=1b370ab2&scoped=true"
import script from "./add-connector.vue?vue&type=script&lang=js"
export * from "./add-connector.vue?vue&type=script&lang=js"
import style0 from "./add-connector.vue?vue&type=style&index=0&id=1b370ab2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b370ab2",
  null
  
)

export default component.exports